import { useNavigate } from "react-router-dom";
import { RouteAccessMap } from "./packages/accessControl/routeAccess";
import UnauthorisedPage from "./packages/components/display/UnauthorisedPage";
import { useUserInfo } from "./packages/context/userinfo/useUserInfo";
import { isAuthorisedRole } from "./packages/utils/utils";

type ProtectedRoutesProps = {
  path: string;
  component: React.ReactNode;
  condition?: boolean;
};

export const getAccessRoles = (path: string, activeTenant?: string | null) => {
  const tenantRoles = activeTenant ? RouteAccessMap[path][activeTenant] : null;

  if (Array.isArray(tenantRoles)) {
    return tenantRoles;
  } else {
    return RouteAccessMap[path].default;
  }
};

const ProtectedRoutes = ({ path, component, condition = true }: ProtectedRoutesProps) => {
  const navigate = useNavigate();
  const userInfo = useUserInfo();
  const currentRoles = userInfo?.data.userInfo?.roles;
  const activeTenant = userInfo?.data?.activeTenant;
  const accessRoles = getAccessRoles(path, activeTenant);
  const isAccessAllowed = condition && isAuthorisedRole(accessRoles ?? [], currentRoles);

  return isAccessAllowed ? (
    component
  ) : (
    <UnauthorisedPage
      errorTitle="Access denied"
      actionText="Go to homepage"
      action={() => navigate("/")}
    />
  );
};
export default ProtectedRoutes;
